import React from "react";
import { Toaster } from "react-hot-toast";
import "swiper/css";
import "./node_modules/flag-icons/css/flag-icons.min.css";
import Layout from "./src/components/layout";
import MaintenancePage from "./src/components/MaintenancePage";
import { MAINTENANCE_MODE } from "./src/maintenance-mode";

// import "aos/dist/aos.css";
// import "react-modal-video/scss/modal-video.scss";
import "./src/styles/global.scss";

export const wrapPageElement = ({ element, props }) => {
  if (MAINTENANCE_MODE) {
    return <MaintenancePage />;
  }

  return (
    <Layout {...props}>
      {element} <Toaster />
    </Layout>
  );
};
